<template>
  <aha-modal
    id="doc-to-quiz__result-modal"
    :size="modalSize"
    :title="modalTitle"
    :iconBeforeModalTitle="iconBeforeModalTitle"
    boxShadow="0 0 1px 8px rgba(255,255,255,0.3)"
    @hide="clickOnCloseDocToSlideResultModal()"
    noCloseOnBackdrop
    :classesModal="{'doc-to-quiz__result-modal': true}"
  >
    <div class="doc-to-quiz__header" id="doc-to-quiz__header"></div>
    <div class="doc-to-quiz__wrapper" id="doc-to-quiz__content-wrapper">
      <div v-for="(quiz, index) in docToSlideResponse" :key="index">
        <AIGeneratedPickAnswerContent
          v-if="quiz.type === AIResponseType.PICK_ANSWER"
          :response="quiz"
          :index="index"
          :isDisabled="isGeneratedContentDisabled(quiz)"
          @handleAddSlideToPresentation="clickOnAddQuizToPresentation"
          class="content-item"
          :class="{'is-first-content-item': index === 0}"
        />
        <AIGeneratedTypeAnswerContent
          v-if="quiz.type === AIResponseType.TYPE_ANSWER"
          :response="quiz"
          :index="index"
          :isDisabled="isGeneratedContentDisabled(quiz)"
          @handleAddSlideToPresentation="clickOnAddQuizToPresentation"
          class="content-item"
        />
      </div>
      <aha-spinner
        v-if="!isDoneGenerating && !isSubmittingFeedback"
        class="mb-4"
        :class="{'hidden': isLoadingSpinnerHidden}"
      ></aha-spinner>
      <div
        v-if="isResponseWithError"
        class="text-center mt-15 rounded"
        :class="{'bg-base-0 m-4': !customAIStumpedText, 'mb-8': customAIStumpedText}"
      >
        <p v-if="responseError" class="w-80">
          {{ responseError }}
        </p>
        <AIStumped v-else :customText="customAIStumpedText" />
      </div>
      <div class="feedback-loading" v-if="isSubmittingFeedback">
        <div class="feedback-loading__content">
          <div class="text-base-100">
            {{ $i18nPresenter.t("Just a moment! Generating your quiz...") }}
          </div>
          <FakeProgressbar :resetProgressBar="loadingProgressBar" />
        </div>
      </div>
    </div>
    <div class="doc-to-quiz__bottom"></div>
    <AIFeedbackButtons
      @handleFeedbackQuiz="clickOnFeedbackButton"
      :isDoneGenerating="isDoneGenerating"
      :allFeedbackButtonTexts="allFeedbackButtonTexts"
      isDocToQuizModal
    />
  </aha-modal>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import AIGeneratedPickAnswerContent from '@/components-v2/presentation-editor/new-slide/OpenAI/AIGeneratedPickAnswerContent.vue'
import AIGeneratedTypeAnswerContent from '@/components-v2/presentation-editor/new-slide/OpenAI/AIGeneratedTypeAnswerContent.vue'
import AIFeedbackButtons from '../openAI/AIFeedbackButtons.vue'
import FakeProgressbar from '@/components-v2/presentation-editor/new-slide/FakeProgressbar.vue'
import AIStumped from '@/components-v2/presentation-editor/new-slide/OpenAI/AIStumped.vue'
import AIResponseType from '@/constant/aiResponseType'

import importStatusConstant from '@/constant/importStatus'
import openAIConstants from '@/constant/openAI'

export default {
  components: {
    AIGeneratedPickAnswerContent,
    AIGeneratedTypeAnswerContent,
    AIStumped,
    FakeProgressbar,
    AIFeedbackButtons,
  },
  props: {
    isDoneGenerating: {
      type: Boolean,
      default: false,
    },
    docToSlideResponse: {
      type: Array,
      default: () => [],
    },
    docToSlideContentLanguage: {
      type: String,
      default: null,
    },
    isSubmittingFeedback: {
      type: Boolean,
      default: false,
    },
    isResponseWithError: {
      type: Boolean,
      default: false,
    },
    responseError: {
      type: String,
      default: null,
    },
    customAIStumpedText: {
      type: Array,
      default: () => [],
    },
    isLoadingSpinnerHidden: {
      type: Boolean,
      default: false,
    },
    loadingProgressBar: {
      type: Number,
      default: 0,
    },
  },
  // mixins: [UndoRedoMixin],
  data() {
    return {
      importStatusConstant,
      allFeedbackButtonTexts: openAIConstants.docToQuizFeedbacks,
      AIResponseType,
      resetProgressBar: 0,
      iconBeforeModalTitle: {
        name: 'sparkles',
        width: 20,
        height: 20,
        viewBox: '0 0 20 20 ',
        maintainColor: true,
      },
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      isNewPresentation: (state) => state.isNewPresentation,
      slideActive: (state) => state.slideActive,
      isEditorRendered: (state) => state.renderPresentationDetail,
    }),
    ...mapGetters(['currentPresenterLanguage']),
    modalSize() {
      return this.isFrenchOrVietnameseUser ? 'lg' : 'md'
    },
    modalTitle() {
      return this.$i18nPresenter.t('AI-Generated Slides')
    },
    isPreviousQuizzesHaveIds() {
      return this.docToSlideResponse.some((quiz) => quiz.id)
    },
    isFrenchOrVietnameseUser() {
      return this.currentPresenterLanguage === 'fr' || this.currentPresenterLanguage === 'vi'
    },
    isGeneratedContentDisabled() {
      return (response) => {
        return response.isDisabled || response.isAddingSlide || !this.isEditorRendered
      }
    },
  },
  methods: {
    ...mapActions([
      'setSlideActiveAction',
    ]),
    ...mapActions('slidesGeneratorFeedback', ['sendFeedbackOnDocumentQuizzes']),
    ...mapActions('docToSlideGenerator', [
      'setDocToSlideImportStageAction',
      'generateDocToSlideUniqueRequestIdAction',
      'handleDocToSlideErrorAction',
      'toggleDocToSlideResultModalAction',
      'setDocToSlideResponseAction',
    ]),

    clickOnFeedbackButton(feedback) {
      this.$emit('clickOnFeedbackButton', feedback)
    },

    clickOnCloseDocToSlideResultModal() {
      this.$emit('clickOnCloseDocToSlideResultModal')
    },

    clickOnAddQuizToPresentation(response) {
      this.$emit('clickOnAddQuizToPresentation', response)
    },
  },
}
</script>

<style>
.doc-to-quiz__result-modal {
  .aha-modal__header {
    @apply bg-primary-50 absolute top-0 w-full z-1;
    .aha-modal__header--text {
      @apply mt-0;
    }
  }
  .aha-modal__body {
    @apply bg-primary-50 p-0 m-0 relative;
    height: unset;
    overflow-x: visible;
    .aha-modal__header--text {
      @apply mt-0;
    }
  }
  .doc-to-quiz__header {
    height: 56px;
  }
  .doc-to-quiz__wrapper {
    @apply rounded text-base m-0 overflow-y-auto py-0 px-6;
    height: 80vh;
    @media (max-width: 768px) {
      height: 70vh;
    }
  }
  .doc-to-quiz__bottom {
    height: 53px;
  }
  .content-item {
    @apply shadow rounded-lg my-4;
    @apply w-full;
    color: #000;
    background-color: #fff;
    &.is-first-content-item {
      margin-top: 0;
    }
    &::v-deep {
      ul {
        list-style: disc;
        padding-left: 1rem;
      }
      p:not(:last-child) {
        padding-bottom: 0.75rem;
      }
    }
  }
  .feedback-loading {
    @apply flex items-center justify-center;
    .feedback-loading__content {
      margin-top: 1.5rem;
    }
  }
}
</style>
